import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ArticlesService } from '../../../articles/core/ArticlesService';
import { IArticleSalesHistoryItem } from '../../../articles/core/interfaces/IArticleSalesHistoryItem';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
    selector: 'app-top-products-last-30-days-chart',
    templateUrl: './top-products-last-30-days-chart.component.html',
    styleUrl: './top-products-last-30-days-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopProductsLast30DaysChartComponent implements OnInit {

  public items: IArticleSalesHistoryItem[] = [];
  public isLoading = false;

  private readonly _articlesService = inject(ArticlesService);
  private readonly _cdr = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.isLoading = true;

    this._articlesService.getTopProductsSalesHistory(10, moment().subtract(30, 'days'), moment())
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this._cdr.markForCheck();
        })
      )
      .subscribe(res => this.items = res);
  }
}
